import { Injectable } from '@angular/core';
import { ITriggerConfigService } from './itriggerconfig.service';
import {SalesforceActionConfigurations} from './salesforce-action-configurations';
import { ITriggerConfig } from './shared-action-configurations';

@Injectable({
  providedIn: 'root',
})
export class SalesforceTriggerConfigService implements ITriggerConfigService {
  getConfigs(): ITriggerConfig[] {
    return SalesforceActionConfigurations.triggerConfigs;
  }
}
